import { observer } from "mobx-react-lite";
import { Col, Row } from "react-bootstrap";
import Button from "@edaz/edazkit/Button/index";
import Icon, { IconType } from "@edaz/edazkit/Icon";
import React from "react";

type RoadMapTooltipProps = {
  roadData: {
    road?: string;
    roadType?: string;
  };
  position: {
    x: number;
    y: number;
  };
  show: boolean;
  onClose?: () => void;
  t: (code: string) => string;
};

const RoadMapTooltip = observer(({ roadData, position, show, onClose, t }: RoadMapTooltipProps) => {
  const { x, y } = position;
  let roadTypeMessage;
  switch (roadData?.roadType) {
    // Paid roads
    case "a":
      roadTypeMessage = t("tollPaidRoad");
      break;
    // Free roads
    case "n":
      roadTypeMessage = t("tollFreeRoad");
      break;
    // Paid only in direction out of the country
    case "p":
    default:
      roadTypeMessage = t("tollPartialRoad");
      break;
  }
  return (
    <>
      {show && roadData.road && (
        <div className="fade kit__tooltip show tooltip bs-tooltip-bottom" style={{ left: x, top: y, position: "fixed" }}>
          <div className="tooltip-inner">
            <div className="m-2 position-relative">
              <Row>
                {onClose && (
                  <Button variant="link" onClick={onClose} className="p-0 m-0 right-corner">
                    <Icon width={8} height={8} className="text-white-50" icon={IconType.Cross} />
                  </Button>
                )}
                <Col xs={12}>
                  <b>{roadData.road}</b>
                  {roadTypeMessage && (
                    <span>
                      <br />
                      {roadTypeMessage}
                    </span>
                  )}
                </Col>
              </Row>
            </div>
          </div>
        </div>
      )}
    </>
  );
});

export default RoadMapTooltip;
